module.exports = __webpack_public_path__ + "static/media/IMG_4600 from lounge wide - Copy.d3b20253.JPG";